<template>
  <v-container class="text-center">
    <h2>Game in progress</h2>
  </v-container>
</template>

<script>

export default {
  name: 'Play',

  data: () => ({
    //
  }),
};
</script>
